export default __webpack_public_path__ + "static/media/vip3.43112359.webp";